import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireBackofficeSession } from '@/lib/require-backoffice-session'

export const Route = createFileRoute('/users')({
	ssr: false,
	beforeLoad: requireBackofficeSession,
	component: UsersLayout
})

function UsersLayout() {
	return <Outlet />
}
